import { render, staticRenderFns } from "./BtnAtualizarPleito.vue?vue&type=template&id=a070ac20"
import script from "./BtnAtualizarPleito.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarPleito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports